/* eslint-disable react/prop-types */
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import CostBreakDownItem from 'components/wise-components/CostBreakDownItem';
import CurrencyInput, {
  countryOptions
} from 'components/wise-components/CurrencyInput';
import { thousandSeparator } from 'helpers/helper';
import React, { useState } from 'react';
import { Button, Dropdown, Offcanvas, Spinner } from 'react-bootstrap';
import { transferFee } from './International';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WiseScheduleModal from 'components/wise-modals/WiseScheduleModal';
import { days, months } from 'data/month';
import { useNavigate } from 'react-router-dom';
import { routePaths } from 'routes/routePaths';

function SameCurrency() {
  const [show, setShow] = useState(false);
  const [showContent, setShowContent] = useState('');
  const [scheduleDate, setScheduleDate] = useState({});
  const [transferType, setTransferType] = useState(transferFee[0]);
  const [showScheduledModal, setShowScheduledModal] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(countryOptions[100]);

  let navigate = useNavigate();

  const handleClose = () => {
    setShow(false);

    setTimeout(() => {
      setShowContent('');
    }, 200);
  };

  const showHandler = contentToShow => {
    if (contentToShow) {
      setShow(true);
      setShowContent(contentToShow);
    }
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Button
      ref={ref}
      onClick={e => {
        e.preventDefault();
        onClick(e);
      }}
      variant="link"
      className="p-0 text-1000 text-decoration-underline fw-medium"
    >
      {children}

      <FontAwesomeIcon icon="angle-down" className="fs--1 ms-2" />
    </Button>
  ));

  return (
    <>
      <CurrencyInput
        label="Recipient gets exactly"
        selectedCurrency={selectedCurrency}
        setSelectedCurrency={setSelectedCurrency}
        shortInfo={
          Object.keys(scheduleDate).length
            ? 'You’ll need to use your balance to schedule this transfer.'
            : ''
        }
      />

      {!Object.keys(scheduleDate).length ? (
        <CostBreakDownItem
          icon="minus"
          itemValue={
            <p className="mb-0 fw-semi-bold fs-0 text-1000 ms-3">
              {thousandSeparator(4.62)} {selectedCurrency.value}
            </p>
          }
          itemInfo={
            <>
              <Dropdown className="d-none d-md-block">
                <Dropdown.Toggle
                  as={CustomToggle}
                  id="dropdown-custom-components"
                >
                  {transferType?.title} fee
                </Dropdown.Toggle>

                <Dropdown.Menu className="c-dropdown">
                  <p className="mb-1 text-900 px-4">Transfer types</p>
                  {transferFee?.map((item, index) => (
                    <Dropdown.Item
                      key={index}
                      className="px-3"
                      onClick={() => setTransferType(item)}
                      as="button"
                    >
                      <div
                        className={`${
                          transferType?.title === item.title &&
                          'bg-primary text-white'
                        } hover-bg-primary align-items-center py-2 px-3 rounded-3`}
                      >
                        <p className="mb-1 fs-0">
                          {item.title} - {item.amount} {selectedCurrency.value}
                        </p>
                        <p className="mb-0 fs--1">{item.debitBy}</p>
                      </div>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <Button
                variant="link"
                className="p-0 text-1000 text-decoration-underline fw-medium d-md-none"
                onClick={() => showHandler('transfer-fee')}
              >
                {transferType?.title} fee
                <FontAwesomeIcon icon="angle-down" className="fs--1 ms-2" />
              </Button>
            </>
          }
        />
      ) : (
        <CostBreakDownItem
          icon="plus"
          itemValue={
            <p className="mb-0 fw-semi-bold fs-0 text-1000 ms-3">
              {thousandSeparator(0)} {selectedCurrency.value}
            </p>
          }
          itemInfo={<p className="mb-0">Estimated balance transfer fee</p>}
        />
      )}

      <Flex className="mt-3" alignItems="center">
        <Avatar
          size="2xl"
          name="Amit Samadder"
          mediaClass="bg-300 text-1000 fs-1"
        />
        <div className="ms-2">
          <p className="mb-0 fs--1">You send</p>
          <p className="mb-0 fw-semi-bold text-1000">
            {thousandSeparator(1000)} {selectedCurrency.value}
          </p>
        </div>
      </Flex>

      <p className="text-700 fs--1 mt-5">
        {Object.keys(scheduleDate).length ? (
          <Button
            variant="link"
            onClick={() => setShowScheduledModal(true)}
            className="d-block bg-transparent border-0 shadow-none mt-1 mb-2 fs--1 p-0 fw-semi-bold text-1000 text-decoration-underline"
          >
            {`Sending on ${new Date(scheduleDate?.date).getDate()}  ${
              months[new Date(scheduleDate?.date).getMonth()]
            }`}
          </Button>
        ) : null}
        Should arrive
        <span className="fw-semi-bold text-1000 ms-1">
          {Object.keys(scheduleDate).length
            ? `by ${days[new Date(scheduleDate?.date).getDay()]}`
            : 'in 2 hours'}
        </span>
      </p>

      <Flex>
        <Button
          onClick={() => setShowScheduledModal(true)}
          className="bg-transparent border-600 shadow-none text-800 rounded-circle p-2 select-calendar-data-btn me-2"
        >
          <FontAwesomeIcon
            icon={
              Object.keys(scheduleDate).length
                ? 'calendar-check'
                : 'calendar-alt'
            }
            size="lg"
          />
        </Button>
        <Button
          variant="primary"
          className="flex-1 rounded-5"
          onClick={() => navigate(routePaths.CONTACT_EXISTING)}
        >
          Continue
          {false && (
            <Spinner
              animation="border"
              className="ms-3"
              size="sm"
              role="status"
            />
          )}
        </Button>
      </Flex>

      <Offcanvas
        show={show}
        placement={'bottom'}
        onHide={handleClose}
        className="c-offcanvas-style"
      >
        <div className="offcanvas-close-line" />

        <Offcanvas.Body className="mt-4">
          {showContent === 'transfer-fee' && (
            <div>
              <p className="mb-3 text-900 px-3">Transfer types</p>
              {transferFee?.map((item, index) => (
                <div
                  onClick={() => {
                    setTransferType(item);
                    handleClose();
                  }}
                  key={index}
                  className={`${
                    transferType?.title === item.title &&
                    'bg-primary text-white'
                  } hover-bg-primary align-items-center py-2 px-3 rounded-3`}
                >
                  <p className="mb-1 fs-0">
                    {item.title} - {item.amount} {selectedCurrency.value}
                  </p>
                  <p className="mb-0 fs--1">{item.debitBy}</p>
                </div>
              ))}
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      <WiseScheduleModal
        show={showScheduledModal}
        handleClose={() => setShowScheduledModal(false)}
        setScheduleDate={setScheduleDate}
      />
    </>
  );
}

export default SameCurrency;
